import { render, staticRenderFns } from "./DamageLossesList.vue?vue&type=template&id=7101efd6"
import script from "@/controllers/custom/damage-losses/damage-losses-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/damage-losses/damage-losses-list.js?vue&type=script&lang=js&external"
import style0 from "./DamageLossesList.vue?vue&type=style&index=0&id=7101efd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports